<p-button
  [label]="buttonLabel()"
  [styleClass]="styleClass()"
  [loading]="loading()"
  [disabled]="isDisabled()"
  [pTooltip]="tooltip()"
  (click)="handleClick($event)"
  appConfirmStepLeaveDirective
></p-button>
